import { useToast } from 'vue-toastification/composition';
import store from '@/store';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

const useTourStatus = () => {
  const toast = useToast();

  const getTourStatusList = async () => {
    try {
      return await store.dispatch('tourStatus/getTourStatus');
    } catch (error) {
      toast.error({
        component: ToastificationContent,
        props: {
          title: 'Tour status not found',
          icon: 'XCircleIcon',
        },
      });
    }
  };

  return {
    getTourStatusList,
  };
};

export default useTourStatus;
